<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="!purchaseId"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer" v-if="!purchaseId">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
    </customize-page>
    <el-dialog
      title="手工放行"
      width="550px"
      :visible.sync="showFormDialog"
      :close-on-click-modal="!actionBusy"
      :before-close="closeManual"
    >
      <el-form
        style="width: 400px; margin: 0 auto"
        ref="form"
        :model="formData"
        label-width="80px"
      >
        <el-form-item label="核注单编号">
          <el-input v-model="formData.businessId"></el-input>
        </el-form-item>
        <el-form-item label="单一窗口编号">
          <el-input v-model="formData.singleWindowNo"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="actionBusy"
            @click="saveManualDeclare"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import heZhuApi from "@/api/heZhuApi";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    let initParam = this.$store.state.app.sc["heZhuOrder"];
    if (initParam) {
      this.pagination.currentPage = initParam.request.pageIndex;
      this.pagination.pageSize = initParam.request.pageSize;
      this.filterObj = initParam.request.condition;
    }
  },
  mounted() {
    this.fetch();
  },
  watch: {
    $route: {
      handler() {
        this.purchaseId = this.$route.params.purchaseId;
        this.fetch();
      },
      deep: true,
    },
  },
  data() {
    return {
      uploadData: {
        _aid: 401,
      },
      showFormDialog: false,
      manualDeclareHeZhuId: null,
      formData: {},
      purchaseId: null,
      uploadName: "CPRODUCT_IMG.xlsx",
      loading: false,
      actionBusy: false,
      dataList: [],
      columns: [
        {
          title: "核注清单编号",
          key: "copListNo",
          width: 200,
          align: "center",
          render: (h, param) => {
            let row = param.row;
            return (
              <el-button
                type="text"
                style={{ color: "#409EFF", padding: "0 10px" }}
                onClick={this.jumpToDetailPage.bind(this, row)}
              >
                {row.copListNo}
              </el-button>
            );
          },
        },
        {
          title: "海关清单编号",
          key: "businessId",
          width: 150,
          align: "center",
        },
        {
          title: "单一窗口号",
          key: "singleWindowNo",
          width: 200,
          align: "center",
        },
        {
          title: "账册号",
          key: "emsNo",
          width: 150,
          align: "center",
        },
        {
          title: "清单类型",
          key: "billType",
          width: 100,
          align: "center",
        },
        {
          title: "经营企业",
          key: "bizOpCompany",
          width: 200,
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <el-tag size="mini">{row.bizOpCompanyName}</el-tag>
                <el-tag size="mini">{row.bizOpCompanyNo}</el-tag>
                <el-tag size="mini">{row.bizOpCompanyCreditNo}</el-tag>
              </div>
            );
          },
        },
        {
          title: "收货企业",
          key: "rcvCompany",
          width: 200,
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <el-tag size="mini">{row.rcvCompanyName}</el-tag>
                <el-tag size="mini">{row.rcvCompanyNo}</el-tag>
                <el-tag size="mini">{row.rcvCompanyCreditNo}</el-tag>
              </div>
            );
          },
        },
        {
          title: "申报企业",
          key: "dclCompany",
          width: 200,
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <el-tag size="mini">{row.dclCompanyName}</el-tag>
                <el-tag size="mini">{row.dclCompanyNo}</el-tag>
                <el-tag size="mini">{row.dclCompanyCreditNo}</el-tag>
              </div>
            );
          },
        },
        {
          title: "监管方式",
          key: "tradeMode",
          width: 100,
          align: "center",
        },
        {
          title: "运输方式",
          key: "transMode",
          width: 100,
          align: "center",
        },
        {
          title: "起运国",
          key: "startShipCountry",
          width: 100,
          align: "center",
        },
        {
          title: "关联账册备案编号",
          key: "rltEmsNo",
          width: 200,
          align: "center",
        },
        {
          title: "关联清单编号",
          key: "rltInvtNo",
          width: 200,
          align: "center",
        },
        {
          title: "申报状态",
          width: 200,
          key: "status",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            const tagType = {
              INIT: ["info", "待申报"],
              DECLARED: ["warning", "已申报"],
              DECLARE_SUCCESS: ["success", "申报成功"],
              DECLARE_FAIL: ["error", "申报失败"],
            };
            return (
              <div>
                <el-tag type={tagType[row.status][0]}>
                  {tagType[row.status][1]}
                </el-tag>
              </div>
            );
          },
        },
        {
          title: "状态描述",
          width: 200,
          key: "statusDesc",
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          fixed: "right",
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <el-button
                  type="text"
                  disabled={this.actionBusy || this.loading}
                  onClick={this.declare.bind(this, row)}
                >
                  申报
                </el-button>
                <el-button
                  type="text"
                  disabled={this.actionBusy || this.loading}
                  onClick={this.manualDeclareSuccess.bind(this, row)}
                >
                  手工放行
                </el-button>
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={this.delete.bind(this, row)}
                >
                  删除
                </a>
              </div>
            );
          },
        },
      ],
      filterObj: {
        originOrderNo: "",
        bizId: "",
      },
      currentRow: [],
    };
  },
  methods: {
    jumpToDetailPage(row) {
      this.$router.push({
        name: "heZhuOrderDetail",
        params: { heZhuOrderId: row.id },
      });
    },
    manualDeclareSuccess(row) {
      if (this.actionBusy) return;
      this.manualDeclareHeZhuId = row.id;
      this.formData = {};
      this.showFormDialog = true;
    },
    closeManual(done) {
      if (!this.actionBusy) done();
    },
    async saveManualDeclare() {
      if (this.actionBusy) return;
      this.actionBusy = true;
      try {
        await this.$confirm("此操作将手工放行核注单, 请确认数据正确", "提示", {
          type: "warning",
        });
      } catch (error) {
        this.actionBusy = false;
        return;
      }
      try {
        const res = await heZhuApi.manualDeclareSuccess({
          request: {
            id: this.manualDeclareHeZhuId,
            singleWindowNo: this.formData.singleWindowNo,
            businessId: this.formData.businessId,
          },
        });
        if (!res.value) throw new Error(res.resultMessage || "放行未确认成功");
        this.showFormDialog = false;
        this.$message.success("放行成功");
      } catch (error) {
        this.$message.error(
          error.msg || error.message || "放行失败，请核实当前状态",
        );
      } finally {
        await this.fetch();
        this.actionBusy = false;
      }
    },
    async declare(row) {
      if (this.actionBusy) return;
      this.actionBusy = true;
      try {
        await this.$confirm("此操作将申报核注单, 请确认数据正确", "提示", {
          type: "warning",
        });
      } catch (error) {
        this.actionBusy = false;
        return;
      }
      try {
        const res = await heZhuApi.declare({ heZhuOrderId: row.id });
        if (!res.success)
          throw new Error(res.resultMessage || "申报未确认成功");
        this.$message.success("申报成功");
      } catch (error) {
        this.$message.error(
          error.msg || error.message || "申报失败，请核实当前状态",
        );
      } finally {
        await this.fetch();
        this.actionBusy = false;
      }
    },
    delete(row) {
      this.$confirm("此操作将删除核注单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        heZhuApi
          .delete({
            heZhuOrderId: row.id,
          })
          .then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.fetch();
          });
      });
    },
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.applyTime != null) {
        let start = filterParams.applyTime[0] + " 00:00:00",
          end = filterParams.applyTime[1] + " 23:59:59";
        filterParams.gmtCreateStart = new Date(start).getTime();
        filterParams.gmtCreateEnd = new Date(end).getTime();
        delete filterParams.applyTime;
      } else {
        delete filterParams.gmtCreateStart;
        delete filterParams.gmtCreateEnd;
      }
      let searchCondition = {
        ...filterParams,
        bizId: this.$route.params.purchaseId,
        type: "IMPORT",
        currentPage: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      heZhuApi.list({ request: searchCondition }).then((res) => {
        this.dataList = res.items;
        this.pagination.currentPage = res.page.pageIndex;
        this.pagination.pageSize = res.page.pageSize;
        this.pagination.totalCount = res.page.totalCount;
        this.loading = false;
      });
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },
    getFormConfig() {
      const type = this.getFormItemType();
      if (this.$route.params.purchaseId) {
        return null;
      }
      return [
        {
          data: [
            {
              label: "采购单来源单号",
              model: "originOrderNo",
              type: type.INPUT,
            },
          ],
        },
      ];
    },
  },
};
</script>

<style>
.avatar-uploader {
  display: inline-block;
}

.inline-p {
  display: inline-block;
}

.inline-p span {
  color: #3399ff;
}

.filter_con.filterUp .filter-form {
  height: auto;
  overflow: visible;
}
</style>
